var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.20001C10.6981 3.20001 6.40003 7.49808 6.40003 12.8V18.5373L5.26866 19.6686C4.81107 20.1262 4.67418 20.8144 4.92183 21.4123C5.16948 22.0102 5.75289 22.4 6.40003 22.4H25.6C26.2472 22.4 26.8306 22.0102 27.0782 21.4123C27.3259 20.8144 27.189 20.1262 26.7314 19.6686L25.6 18.5373V12.8C25.6 7.49808 21.302 3.20001 16 3.20001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 28.8C13.349 28.8 11.2 26.651 11.2 24H20.8C20.8 26.651 18.651 28.8 16 28.8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWhiteIcon);
export default __webpack_public_path__ + "static/media/notification_white_icon.606dc5d3d31b82f31f34e358c9ec2a79.svg";
export { ForwardRef as ReactComponent };